import { FloorPlanSiteParamsSchema, SiteTelemetrySettingsPatchBodySchema, SiteTelemetrySettingsResponseSchema, } from '../../schemas.js';
import { LocationTagGeofencingByTagParamsSchema, LocationTagGeofencingParamsSchema, LocationTagGeofencingPatchBodySchema, LocationTagGeofencingResponseSchema, } from '../../location-tag-registry.schema.js';
const locationBase = { base: 'location' };
/** REST contract for spatial-service tenant telemetry + geofencing routes. */
export const locationTelemetryContract = {
    getSiteTelemetrySettings: {
        method: 'GET',
        path: '/location/sites/:siteId/telemetry-settings',
        pathParams: FloorPlanSiteParamsSchema,
        response: SiteTelemetrySettingsResponseSchema,
        responseStyle: 'parse-response',
        errorMessage: 'Failed to get site telemetry settings',
        ...locationBase,
    },
    putSiteTelemetrySettings: {
        method: 'PUT',
        path: '/location/sites/:siteId/telemetry-settings',
        pathParams: FloorPlanSiteParamsSchema,
        body: SiteTelemetrySettingsPatchBodySchema,
        response: SiteTelemetrySettingsResponseSchema,
        responseStyle: 'parse-response',
        errorMessage: 'Failed to update site telemetry settings',
        ...locationBase,
    },
    getTagGeofencingBySite: {
        method: 'GET',
        path: '/location/sites/:siteId/tags/:tagId/geofencing',
        pathParams: LocationTagGeofencingParamsSchema,
        response: LocationTagGeofencingResponseSchema,
        responseStyle: 'parse-response',
        errorMessage: 'Failed to get tag geofencing settings',
        ...locationBase,
    },
    patchTagGeofencingBySite: {
        method: 'PATCH',
        path: '/location/sites/:siteId/tags/:tagId/geofencing',
        pathParams: LocationTagGeofencingParamsSchema,
        body: LocationTagGeofencingPatchBodySchema,
        response: LocationTagGeofencingResponseSchema,
        responseStyle: 'parse-response',
        errorMessage: 'Failed to update tag geofencing settings',
        ...locationBase,
    },
    getTagGeofencingByTag: {
        method: 'GET',
        path: '/location/tags/:tagId/geofencing',
        pathParams: LocationTagGeofencingByTagParamsSchema,
        response: LocationTagGeofencingResponseSchema,
        responseStyle: 'parse-response',
        errorMessage: 'Failed to get tag geofencing settings',
        ...locationBase,
    },
    patchTagGeofencingByTag: {
        method: 'PATCH',
        path: '/location/tags/:tagId/geofencing',
        pathParams: LocationTagGeofencingByTagParamsSchema,
        body: LocationTagGeofencingPatchBodySchema,
        response: LocationTagGeofencingResponseSchema,
        responseStyle: 'parse-response',
        errorMessage: 'Failed to update tag geofencing settings',
        ...locationBase,
    },
};
//# sourceMappingURL=location-telemetry.contract.js.map